exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_listElementHeader_1n0PA5uDT4TCs2-4tpAFRX {\n  width: 100%;\n  margin-bottom: 10px;\n  display: flex;\n  overflow: hidden;\n  font-size: 12px;\n  padding-left: 15px;\n  box-sizing: border-box;\n}\n\n.IA_previewColumn_3HMog3T6gT1tKTTHZ95l6T {\n  flex: 0.2;\n}\n\n.IA_iconColumn_RMsJ3I0Hxyqwn6rNb4eZ8 {\n  flex: 0.4;\n  padding-right: 10px;\n  box-sizing: border-box;\n}\n\n.IA_dateColumn_24u9JWUdXYQ2hIAmpvQZXf {\n  flex: 0.5;\n}\n\n.IA_column_kMg36PTx8HT8yUV0px8YO {\n  flex: 1;\n}\n\n.IA_buttons_2s-S7N7KHeriqngnFdBJQT {\n  padding-right: 10px;\n}", ""]);

// Exports
exports.locals = {
	"IA_listElementHeader": "IA_listElementHeader_1n0PA5uDT4TCs2-4tpAFRX",
	"IA_previewColumn": "IA_previewColumn_3HMog3T6gT1tKTTHZ95l6T",
	"IA_iconColumn": "IA_iconColumn_RMsJ3I0Hxyqwn6rNb4eZ8",
	"IA_dateColumn": "IA_dateColumn_24u9JWUdXYQ2hIAmpvQZXf",
	"IA_column": "IA_column_kMg36PTx8HT8yUV0px8YO",
	"IA_buttons": "IA_buttons_2s-S7N7KHeriqngnFdBJQT"
};